<h2 mat-dialog-title>
  @if (truckSearch?.id) {
    Update Truck Search
  } @else {
    New Truck Search
  }
</h2>

<form [formGroup]="form" (ngSubmit)="saveSearch()">
  <mat-dialog-content class="truck-search-dialog-content">
    <div class="template-row">
      <mat-form-field
        appearance="outline"
        [formGroup]="templateForm"
        class="template-field"
      >
        <mat-label>Template</mat-label>

        <mat-select formControlName="id" (selectionChange)="onTemplateChange()">
          <mat-option [value]="null">None</mat-option>

          @for (template of templates; track template.id) {
            <mat-option [value]="template.id">
              {{ template.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="template-actions">
        <button mat-icon-button matTooltip="Add" type="button" (click)="addTemplate()">
          <mat-icon>add_circle_outline</mat-icon>
        </button>

        @if (templateForm.get('id')?.value) {
          <button mat-icon-button matTooltip="Copy" type="button" (click)="addTemplate('copy')">
            <mat-icon>content_copy</mat-icon>
          </button>

          <button mat-icon-button matTooltip="Update" type="button" (click)="updateTemplate()">
            <mat-icon>update</mat-icon>
          </button>

          <button mat-icon-button matTooltip="Delete" type="button" (click)="deleteTemplate()">
            <mat-icon>highlight_remove</mat-icon>
          </button>
        }
      </div>
    </div>

    <div class="filters-form">
      <div class="inline-row origin-row">
        <mat-form-field appearance="outline" class="location-field">
          <mat-label>Origin</mat-label>

          <input
            #originInput
            matInput
            formControlName="origin"
            [matAutocomplete]="pickAuto"
            (input)="filterOrigin()"
          />

          <span matSuffix class="autocomplete-spinner">
            @if (loadingOrigin()) {
              <mat-spinner diameter="20"></mat-spinner>
            }
          </span>

          <mat-autocomplete requireSelection #pickAuto="matAutocomplete">
            @for (option of filteredOriginOptions; track option.id) {
              <mat-option
                [value]="formatLocation(option)"
                (onSelectionChange)="onOriginSelected(option)"
              >
                {{ formatLocation(option) }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>

        @if(!isMobile) {
          <mat-form-field appearance="outline" class="radius-field">
            <mat-label>Radius</mat-label>
            <input matInput type="number" formControlName="origin_radius" step="25" />
            <span matTextSuffix>mi</span>

            @if (form.get('origin_radius')?.hasError('max')) {
              <mat-error>
                Max is {{ maxSearchRadius }} mi.
              </mat-error>
            }

            @if (form.get('origin_radius')?.hasError('min')) {
              <mat-error>
                Min is {{ minSearchRadius }} mi.
              </mat-error>
            }
          </mat-form-field>

        }

      </div>

      @if(isMobile) {
        <mat-form-field appearance="outline" class="radius-field">
          <mat-label>Radius</mat-label>
          <input matInput type="number" formControlName="origin_radius" step="25" />
          <span matTextSuffix>mi</span>
        </mat-form-field>

        @if (form.get('origin_radius')?.hasError('max')) {
          <mat-error>
            Maximum radius is {{ maxSearchRadius }} miles
          </mat-error>
        }

        @if (form.get('origin_radius')?.hasError('min')) {
          <mat-error>
            Minimum radius is {{ minSearchRadius }} miles
          </mat-error>
        }
      }

      <mat-divider class="form-divider"></mat-divider>

      <mat-form-field appearance="outline" class="date-range-field">
        <mat-label>Available Date Range</mat-label>

        <mat-date-range-input [rangePicker]="availablePicker">
          <input
            matStartDate
            placeholder="Start date"
            formControlName="available_start_date"
            [min]="today"
          />

          <input
            matEndDate
            placeholder="End date"
            formControlName="available_end_date"
            [min]="today"
          />
        </mat-date-range-input>

        <mat-datepicker-toggle
          matIconSuffix
          [for]="availablePicker"
        ></mat-datepicker-toggle>

        <mat-date-range-picker #availablePicker></mat-date-range-picker>

        @if (form.get('available_start_date')?.hasError('pastDate')) {
          <mat-error>Start date cannot be in the past</mat-error>
        } @else if (form.get('available_start_date')?.invalid) {
          <mat-error>Invalid start date</mat-error>
        }

        @if (form.get('available_end_date')?.hasError('pastDate')) {
          <mat-error>End date cannot be in the past</mat-error>
        } @else if (form.get('available_end_date')?.invalid) {
          <mat-error>Invalid end date</mat-error>
        }
      </mat-form-field>

      <button
        mat-icon-button
        class="clear-button"
        type="button"
        matTooltip="Clear Date Range"
        (click)="clearDateRange()"
      >
        <mat-icon>clear</mat-icon>
      </button>

      <mat-divider class="form-divider"></mat-divider>

      <mat-form-field appearance="outline" class="small-field">
        <mat-label>Min Well Length</mat-label>
        <input matInput type="number" formControlName="min_well_length" step="12" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="small-field">
        <mat-label>Min Weight</mat-label>
        <input matInput type="number" formControlName="min_weight" step="1000" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="small-field">
        <mat-label>Min Axles</mat-label>
        <input matInput type="number" formControlName="min_axle_count" step="1" />
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="clearFilters()">Clear</button>

    <button mat-button type="button" (click)="close()">Close</button>

    <button 
      mat-button 
      class="lightgreen-button" 
      type="submit"
      [disabled]="form.invalid"
      >
      {{ truckSearch?.id ? 'Update' : 'Search' }}
    </button>
  </mat-dialog-actions>
</form>